












import { Component, Vue, Prop } from 'vue-property-decorator';
import CalendarMonth from '@/components/CalendarMonth.vue';
import moment from 'moment';

@Component({
  components: {
    CalendarMonth,
  },
})
export default class CalendarGrid extends Vue {
  @Prop({ default: 1970 }) public readonly year!: number;
  @Prop({ required: true }) public readonly variablePricingDates!: [];

  public tab = 'week';

  private switchView(tab = 'week') {
    this.tab = tab;
    this.$emit('switchYear', {
      year: moment().format('YYYY'),
    });
  }
}
